import { createSlice, isAnyOf } from "@reduxjs/toolkit";
import { getBrand, getParticularPage, getNext, getPrevious, createBrand, updateBrand, handleSearch } from "./thunk";

const initialState = {
  brands: [],
  edit: false,
  brand: null,
  count: null,
  pageNo: 1,
  next: null,
  previous: null,
  loading: false,
  loadingUpdated: false,
  loadingBrand: false,
  loadingNext: false,
  showCreateModal: false,
  // Form persistence state
  formData: {
    name: "",
    isActive: true,
  },
  activeBrandId: null,
};

export const brandSlice = createSlice({
  name: "brand",
  initialState,
  reducers: {
    setShowCreateModal: (state, action) => {
      state.showCreateModal = action.payload;
    },
    goToPage: (state, { payload }) => {
      state.pageNo = payload;
    },
    brandEditSuccess: (state, action) => {
      state.edit = true;
      state.brand = state.brands.find((brand) => brand.id === action.payload);
      state.formData = state.brands.find((brand) => brand.id === action.payload);
      state.activeBrandId = action.payload;
    },

    resetBrandForm: (state, action) => {
      if (action.payload) {
        // if edit is true, reset to brand data
        state.formData = state.brand;
      } else {
        state.formData = initialState.formData; // if edit is false, reset to initial state
        state.activeBrandId = null;
      }
    },
    // New reducers for form persistence
    saveBrandForm: (state, action) => {
      state.formData = action.payload;
    },
    clearAllBrand: (state) => {
      state.edit = false;
      state.loading = false;
      state.loadingUpdated = false;
      state.loadingBrand = false;
      state.brand = null;
      state.formData = initialState.formData;
      state.activeBrandId = null;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(createBrand.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(createBrand.fulfilled, (state, action) => {
      state.loading = false;
      state.edit = false;
      state.formData = initialState.formData; // Clear form on success
    });
    builder.addCase(createBrand.rejected, (state) => {
      state.loading = false;
      state.edit = false;
    });
    builder.addCase(updateBrand.pending, (state) => {
      state.loadingUpdated = true;
    });
    builder.addCase(updateBrand.fulfilled, (state, action) => {
      state.loadingUpdated = false;
      state.edit = false;
      state.formData = initialState.formData; // Clear form on success
    });
    builder.addCase(updateBrand.rejected, (state) => {
      state.loadingUpdated = false;
    });
    builder.addMatcher(
      isAnyOf(getBrand.pending, getParticularPage.pending, getPrevious.pending, getNext.pending, handleSearch.pending),
      (state) => {
        state.loadingBrand = true;
      }
    );
    builder.addMatcher(
      isAnyOf(
        getBrand.fulfilled,
        getParticularPage.fulfilled,
        getPrevious.fulfilled,
        getNext.fulfilled,
        handleSearch.fulfilled
      ),
      (state, action) => {
        state.loadingBrand = false;
        state.brands = action.payload.data;
        state.count = action.payload.totalCount;
        state.previous = action.payload.previous;
        state.next = action.payload.next;
      }
    );
    builder.addMatcher(
      isAnyOf(
        getBrand.rejected,
        getParticularPage.rejected,
        getPrevious.rejected,
        getNext.rejected,
        handleSearch.rejected
      ),
      (state) => {
        state.loadingBrand = false;
      }
    );
  },
});

export const {
  setShowCreateModal,
  goToPage,
  brandEditSuccess,
  saveBrandForm,
  resetBrandForm,
  clearBrandForm,
  clearAllBrand,
} = brandSlice.actions;

export default brandSlice.reducer;
